export enum ProductAddRemoveLocationType {
  StickyFooter = "Sticky Footer",
  Page = "Page",
  Footer = "Footer",
  PopUp = "Pop Up",
  MiniBag = "MINI_BAG",
}

let membershipLocationTypeSegment = ProductAddRemoveLocationType.Page

export const getMembershipLocationTypeSegment =
  (): ProductAddRemoveLocationType => {
    const locationType = membershipLocationTypeSegment
    setMembershipLocationTypeSegment(ProductAddRemoveLocationType.Page)
    return locationType
  }

export const setMembershipLocationTypeSegment = (
  locationType: ProductAddRemoveLocationType
): void => {
  membershipLocationTypeSegment = locationType
}
